import { useRecoilState } from 'recoil';
import { bannerOpenState } from '../atoms/banner';
import { Box, Button } from '@mui/material';
import { t } from 'i18next';
import CloseSidebarIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import OpenSidebarIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

function BannerSelector() {
    const [isOpen, setIsOpen] = useRecoilState(bannerOpenState)
    
    const handleBannerOpen = () => {
        setIsOpen(!isOpen)
    }
    
    return (
        <>
        {!isOpen ?
            <div className='open-sidebar' style={{position: 'absolute', top: 60, right: 20}}>
                <Button variant='text' sx={{ padding: 0, minWidth: 0 }} onClick={handleBannerOpen}>
                    <OpenSidebarIcon fontSize='large' color="primary" role="button" titleAccess={t('MOSTRA BANNER')}/>
                </Button>
            </div>            
        :
            <Box sx={{height: 0, zIndex: 2, position: 'sticky', top: '8px', cursor: 'pointer' }} onClick={handleBannerOpen}>                
                <CloseSidebarIcon color="secondary" sx={{ fontSize: '2.1875rem'}} role="button" titleAccess={t('NASCONDI BANNER')}/>
            </Box>
        }
    </>
    )
}

export default BannerSelector;